import React from "react";
import LModal from "./LModal/LModal";

interface ISimpleContentModal {
    isOpen: boolean;
    onClose: (isContinue: boolean) => void;
    header: string;
    content: string;
}

const SimpleContentModal: React.FC<ISimpleContentModal> = (props) => {
    const { isOpen, onClose, header, content } = props;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="wide"
            removePadding={true}
            isOpen={isOpen}
            onClose={() => onClose(false)}>
            {() => {
                return (
                    <div className={"modal-container"}>
                        <h2>{header}</h2>
                        <a href="javascript:;" className={"btn-modal-close"} onClick={() => onClose(false)}>
                            Close
                        </a>
                        <div className={"layout-modal-content"} dangerouslySetInnerHTML={{ __html: content }}></div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default SimpleContentModal;
